import { Component } from '@angular/core';
import { PrimeNGModule } from '../../primeng.module';
import { ContactService } from '../../services/contact/contact.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';

@Component({
  selector: 'app-dealer',
  standalone: true,
  imports: [BreadcrumbComponent, ContactFormComponent, PrimeNGModule],
  templateUrl: './dealer.component.html',
  styleUrl: './dealer.component.scss',
})
export class DealerComponent {
  public typeDealer = ContactService.TYPE_DEALER;

  constructor() {}
}
